/**
 * HVP Prototype Mixin Helper
 *
 * Installs a plain object of methods onto a class prototype using the SAME
 * property descriptors the JS engine gives class methods (writable,
 * non-enumerable, configurable). That equivalence is the point: method groups
 * can live in sibling modules for the 350-line rule while instances behave
 * exactly as if the methods were declared inline in the class body — same
 * `this`, same prototype chain, same (non-)enumerability, so nothing that
 * walks an instance or its prototype can tell the difference.
 *
 * Mixins must be applied at module-evaluation time, before any instance is
 * constructed.
 *
 * @package HaruVariationsPro
 * @version 1.0.0
 */

/**
 * Copy every own method of `methods` onto `target`.
 *
 * @param {Object} target - Prototype to extend.
 * @param {Object} methods - Object literal of methods.
 * @returns {Object} The target prototype.
 */
export function applyMixin(target, methods) {
    Object.keys(methods).forEach(name => {
        Object.defineProperty(target, name, {
            value: methods[name],
            writable: true,
            enumerable: false,
            configurable: true
        });
    });

    return target;
}

export default applyMixin;
